// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1h5Y7","icon":"SortAdornment_icon___TPkQ","up":"SortAdornment_up__GrDRz","down":"SortAdornment_down__yTz7L","active":"SortAdornment_active__1y4r0"};